module.exports = __webpack_public_path__ + "man-2.svg?eb0e8986f2fb85629b1e78ec254e0dbe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/man-2.svg
// module id = 55
// module chunks = 0